<div class="container">
  <app-excel-upload
    postUrl="{{ serverURL }}/project/new"
    (success)="onSuccess($event)"
  ></app-excel-upload>
</div>
